<template>
  <div class="box">
    <ion-img v-show="yes" @click="select('yes')" class="img" src="/assets/image/yes.png"></ion-img>
    <ion-img v-show="yes_active" class="img" src="/assets/image/yes-active.png"></ion-img>
    <ion-img v-show="no" @click="select('no')" class="img" src="/assets/image/no.png"></ion-img>
    <ion-img v-show="no_active" class="img" src="/assets/image/no-active.png"></ion-img>
    <img class="preload" src="/assets/image/yes-active.png" alt="" aria-hidden="true" />
    <img class="preload" src="/assets/image/no-active.png" alt="" aria-hidden="true" />
  </div>
</template>

<script>
import {IonImg} from "@ionic/vue";
import common from "../../common";

export default {
  name: "TestTick",
  components: {
    IonImg
  },
  props: {
    record_initial_time: {type: Number, default: 0},
  },
  data() {
    return {
      yes: true,
      yes_active: false,
      no: true,
      no_active: false,
      value: 0,
      seq: 1,
    }
  },
  methods: {
    select: function (option) {
      if (option === 'yes') {
        this.yes = this.no_active = false;
        this.yes_active = this.no = true;
        this.value = 1;
      } else {
        this.yes_active = this.no = false;
        this.yes = this.no_active = true;
        this.value = 0;
      }
      this.$emit('getAnswer', this.value);
      this.$emit('showConfirmBtn')

      this.$emit('addActionSequence', {
        seq: this.seq++,
        x: event.x * window.devicePixelRatio,
        y: event.y * window.devicePixelRatio,
        input_time: common.getTestRecordTime(this.record_initial_time),
        choice: option,
      })
    },
    initData: function () {
      Object.assign(this.$data, this.$options.data());
    },
  }
}
</script>

<style scoped>
  .box{
    display: flex;
    justify-content: center;
    gap: clamp(1.5rem, 5vw, 3rem);
  }
  .img{
    width: clamp(2.75rem, 10vw, 4rem);
    display: inline-block;
    margin: 0;
  }

  .preload{
    position: absolute;
    width: 1px;
    height: 1px;
    opacity: 0;
    pointer-events: none;
  }
</style>
